export default __webpack_public_path__ + "static/media/login-img-4.f299a05f.jpeg";